import { GroupingsTranslation } from 'locales/de/pages/AWPM-FWPM/groupings';

const en: GroupingsTranslation = {
  title: 'Grouping',
  modal: {
    createGroupingTitle: 'Create Grouping',
    editGroupingTitle: 'Edit Grouping',
    groupingName: 'Group name',
    description: 'Description'
  },
  alerts: {
    errorLoadingGroupings: 'Groups could not be loaded!',
    errorCreatingGrouping: 'Groups could not be created!',
    errorEditingGroupings: 'Groups could not be edited!',
    errorDeletingGrouping: 'Groups could not be deleted!',
    successCreatingGrouping: 'Group was created successfully!',
    successEditingGrouping: 'Group was edited successfully!',
    successDeletingGrouping: 'Group was deleted successfully!'
  },
  deleteConfirm: {
    title: 'Really delete?',
    message: 'Are you sure you want to delete this grouping?'
  }
};

export default en;
